import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="card">
      <h2 className="card-title">{t('notFound.title')}</h2>
      <p className="card-subtitle">{t('notFound.subtitle')}</p>
      <Link to="/register" className="text-link">{t('notFound.toRegister')}</Link>
    </div>
  );
}
